/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels200,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";
import { ePaymentMethodSchema } from "../ePaymentMethodSchema.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParamsSchema =
  z
    .object({
      paymentMethod: z.optional(
        z
          .lazy(() => ePaymentMethodSchema)
          .describe(
            "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
          ),
      ),
      currentNumberParcels: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse>;
